export const AWS_DEFAULT_BACKGROUND_IMAGE = 'assets/img/auth_background.webp';

export const AWS_DEFAULT_LOGO = 'https://solvacelabs-webcomponents.s3.amazonaws.com/images/company-logo.jpg';

export const AWS_DEFAULT_LOGO_NG = 'assets/img/logo-solvace-default-ng.svg';

export const AWS_DEFAULT_LOGO_SOLVACE = 'assets/img/logo-solvace-default.svg';
